import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../../../utils/resources/fonts';
import { Colors } from '../../../../../../utils/resources/colors';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export interface MyTonesCardCSSStyle extends UIComponentCSSStyle
{
    getToneDetailDivCSSStyle():object;
    getRoundProfileImageDivCSSStyle():object;
    getDefaultStatusCSSStyle():object;
    getDefaultLabelCSSStyle():object;
    getToneDivCSSStyle():object;
    getToneNameLabelCSSStyle():object;
    getArtistNameLabelCSSStyle():object;
    getRowHeaderDivCSSStyle():object;
    getRowContentDivCSSStyle():object;
    getRepeatLabelCSSStyle():object;
    getRowLabel1CSSStyle():object;
    getRowLabel2CSSStyle():object;
    getRowLabel3CSSStyle():object;
    getBarDivCSSStyle():object;
    getFromDateLabelCSSStyle():object;
    getToDateLabelCSSStyle():object;
    getDeleteButtonCSSStyle():object;
    getRepeatDivCSSStyle():object;

}

export class MyTonesCardCSSStyleImpl extends UIComponentCSSStyleImpl implements MyTonesCardCSSStyle
{
   getWrapperCSSStyle():object
   {
       return{
        width:'300px', 
        height:'auto',
        position:'relative',
        borderRadius:'4px 4px 0px 0px', 
        boxShadow: '0px 10px 25px #0000000A',
        border: "1px solid #EDEDED",
        backgroundColor:this.getResources().getColor(Colors.color_5),
        marginBottom: "25px",
        opacity: 1
       };
   }

  
   getToneDetailDivCSSStyle():object
   {
       return{
       };
   }

   getRoundProfileImageDivCSSStyle():object
   {
       return{
        width:'100%',height:'165px',display:'flex',borderRadius:'50px 0px 50px 0px'
           };
   }
   getDefaultStatusCSSStyle():object{
       return{
        width:"128px",height:"48px",top:"65px", textAlign:"center",
        // right:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH && "265.9px",
        // left:this.getContext().getUserContext().getLanguage() === LanguageConst.ARABIC && "265.9px" ,position:"relative",zIndex:1000
       };
   }

   getDefaultLabelCSSStyle():object
   {
       return{
        width:"100%",position:"absolute",top:"10px",
        left:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH && "-10px",
        right:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH && "-10px",
        zIndex:1001, height:"100%",lineHeight:"27px",color:"#000000",fontSize:"20px",fontWeight:"bold",
       };
   }
   getToneDivCSSStyle():object
   {
       return{
        width:'100%',marginTop:'15px', marginLeft:'15px',height:'60px',position:'relative',display:'flex'
       };
   }

   getToneNameLabelCSSStyle():object
   {
       return{
        width:'100%',
        height:'22px', 
        lineHeight:'22px', 
        fontWeight:'900',

        fontSize:this.getResources().getFont(Fonts.h8),
        fontFamily:this.getResources().getFontFamily(),
        color:this.getResources().getColor(Colors.color_6),
        letterSpacing:'0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
       };
   }

   getArtistNameLabelCSSStyle():object
   {
       return{
        width:'100%',         
        fontWeight:'300',
        marginTop:"15px",
        height:'17px', 
        lineHeight:'17px', fontSize:this.getResources().getFont(Fonts.h6),
        color:this.getResources().getColor(Colors.color_7),
        fontFamily:this.getResources().getFontFamily(),
        letterSpacing:'0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
       };
   }

   getRowHeaderDivCSSStyle():object
   {
       return{
        width:'100%', 
        height:'20px', 
        lineHeight:'20px',
        fontWeight:'300',

         margin:'0px 15px 0px 15px',
        color:this.getResources().getColor(Colors.color_7), 
        fontSize:this.getResources().getFont(Fonts.h6),
        fontFamily:this.getResources().getFontFamily(),

        display:'flex'
       };
   }
   getRepeatLabelCSSStyle():object
   {
       return{
        width:'20%',
        height:'20px',
        textAlign:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'left':"left"
       };
   }
   
   getRowContentDivCSSStyle():object
   {
       return{
        width:'100%', 
        height:'20px',
        margin:'0px 15px 10px 15px',
        fontWeight:'500',

        lineHeight:'20px',
        color:this.getResources().getColor(Colors.color_6), 
        fontSize:this.getResources().getFont(Fonts.h7),
        display:'flex'
       };
   }
   getRowLabel1CSSStyle():object
   {
       return{
        height:'100%', 
        width:'24%',
        fontWeight: "600",
        textAlign:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'left':'left',
       };
   }

   getRowLabel2CSSStyle():object
   {
       return{
        height:'100%', 
        width:'30%',
        fontWeight: "600",
        textAlign:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'left':"left",
        letterSpacing:'0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
       };
   }

   getRowLabel3CSSStyle():object
   {
       return{
        height:'100%', 
        width:'40%',
        fontWeight: "600",
        textAlign:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'left':"left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow:"ellipsis",
        minWidth:"100px"
       };
   }

   getBarDivCSSStyle():object
   {
       return{
        width:'90%', 
        height:'1px',
        margin:'10px 15px 10px 15px', 
        backgroundColor:this.getResources().getColor(Colors.color_17)
       };
   }

   getFromDateLabelCSSStyle():object
   {
       return{
        height:'100%', 
        width:'50%',
        fontWeight: "600",
        textAlign:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'left':"left",
       };
   }

   getToDateLabelCSSStyle():object
   {
       return{
        height:'100%', 
        width:'50%',
        fontWeight: "600",
        textAlign:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'left':"left",
       };
   }
   getDeleteButtonCSSStyle():object
   {
       return{
        width:'30px', 
        height:'30px',
        alignItems:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'right':"right",
        cursor: "pointer",
        marginRight:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'20px':"20px",
        marginTop:'5px',
        marginLeft:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'auto':"auto",
       };
   }

   getRepeatDivCSSStyle():object
   {
       return{
        width:'100%', height:'40px', display:'flex',
        fontWeight:'300',

        marginTop:'5px',marginLeft:'15px',
       };
   }

}    


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/mytonescard/mytonescardcss.tsx